module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-reporting reporting card"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('card7', {
    attrs: {
      "showBullets": true,
      "showAction": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reporting-action-buttons', {
    attrs: {
      "reporting": _vm.item
    }
  })], 1)], 1), _c('reporting-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reporting-id'
    },
    slot: "n1"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reporting-name'
    },
    slot: "n1"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'reporting-driver-info'
    },
    slot: "n2"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reporting-location'
    },
    slot: "n3"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reporting-vehicle'
    },
    slot: "n4"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'reporting-reported-at'
    },
    slot: "n5"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'reporting-updated-at'
    },
    slot: "n6"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'reporting-status'
    },
    slot: "n7"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reporting',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('reservation')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('card-n', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 3
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reporting-action-buttons', {
    attrs: {
      "reporting": _vm.item
    }
  })], 1)], 1), _c('reporting-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reporting-id'
    },
    slot: "n1"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reporting-name'
    },
    slot: "n1"
  }), _c('reporting-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'reporting-reported-at'
    },
    slot: "n2"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reporting',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ed16a47!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Reporting.vue
// module id = 2320
// module chunks = 1